import getSocket from './getSocket';
import { makeBatchDispatcher } from '../actions/conversation';
export class V2Manager {
    constructor(webRTCManager, dispatch, avaId) {
        //this.ws = new WebSocket('ws://localhost:8080');
        this.ws = new WebSocket('wss://backend2-auh6rfwiva-uw.a.run.app');
        this.dispatch = dispatch;
        this.avaId = avaId;
        this.webRTCManager = webRTCManager;
        this.ws.addEventListener('open', this.initialize.bind(this));
    }
    initialize() {
        this.ws.send(JSON.stringify({
            type: 'setAvaId',
            data: {
                avaId: this.avaId,
            },
        }));
        this.webRTCManager.initialize((message) => {
            this.ws.send(JSON.stringify({
                type: 'webrtc',
                data: message,
            }));
        });
        const [batchDispatch, cancelBatchDispatch] = makeBatchDispatcher(this.dispatch);
        this.ws.addEventListener('message', (ev) => {
            const msg = JSON.parse(ev.data);
            if (msg.type === 'webrtc') {
                this.webRTCManager.handleV1Message(msg.data);
            }
            else if (msg.type === 'transcript-edit') {
                const v1Socket = getSocket();
                v1Socket.send(JSON.stringify(msg.data));
                batchDispatch({
                    type: 'RECEIVED_SCRIBE_CONVERSATION_TRANSCRIPT_MUTATION',
                    mutation: msg.data.data.mutation,
                    origin: 'human',
                    transcriptId: msg.data.data.transcriptId,
                });
            }
        });
    }
}
